import { FC, useState } from "react";
import { Collapse, List, Button, Typography, Box } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useLocation } from "react-router";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useCollapseSubMenuStyles } from "./styles";

interface AutoSelectProps {
  Icon: any;
  data: {
    name: string;
    subList: SubMenuProps[];
  };
  mainClasses: { [key: string]: string };
  isOptionActive: boolean;
  isMenuOpen: boolean;
  secondAction?: () => void;
}

interface SubMenuProps {
  id: string;
  Icon: any;
  path: string;
  link: () => void;
  permissionKey: number[];
  name: string;
}

export const CollapseSubMenu: FC<AutoSelectProps> = ({
  Icon,
  data,
  mainClasses,
  isOptionActive,
  isMenuOpen,
  secondAction,
}) => {
  const classes = useCollapseSubMenuStyles();
  const params = useLocation();
  const [active, setActive] = useState(false);
  const { userData } = useTypeSelectors((state) => state.auth);
  const { activeNavLinkList } = useTypeSelectors((state) => state.settings);

  return (
    <>
      <Button
        fullWidth
        color="primary"
        variant={"contained"}
        onClick={() => setActive(!active)}
        disableElevation
        className={`${mainClasses.collapseMenuLink} ${isOptionActive && mainClasses.activeMenuLink}`}
      >
        <Box className={mainClasses.collapseMenuBox}>
          <Icon style={{ color: "currentColor" }} />
          {isMenuOpen && (
            <Typography variant="body2">
              {data.name}
            </Typography>
          )}
        </Box>
        {active ? <ExpandLess /> : <ExpandMore />}
      </Button>
      <Collapse in={active} timeout="auto" unmountOnExit className={classes.collapse}>
        <List component="div" disablePadding>
          {data.subList
            .filter((subLink) => subLink.permissionKey.includes(userData.role))
            .filter((subLink: SubMenuProps) =>
              activeNavLinkList.some((someParentLink) =>
                someParentLink.subList.some((item) => item.id === subLink.id),
              ),
            )
            .map(({ Icon, ...el }: SubMenuProps) => {
              const isActiveSubMenu =
                (params?.pathname === el.path &&
                  params?.pathname.split("/")[1] === el.path.split("/")[1]) ||
                (params?.pathname.split("/")[1] === el.path.split("/")[1] &&
                  !isNaN(Number(params?.pathname.split("/")[2])));

              return (
                <Button
                  key={el.id}
                  fullWidth
                  color="primary"
                  variant={"contained"}
                  onClick={() => {
                    if (secondAction) {
                      secondAction();
                    }
                    el.link();
                  }}
                  disableElevation
                  className={`${classes.subMenuLink} ${isActiveSubMenu && classes.activeSubMenuLink}`}
                >
                  <Icon style={{ color: "currentColor" }} />
                  {isMenuOpen && (
                    <>
                      <Typography variant="body2" style={{ marginLeft: 10 }}>
                        {el.name}
                      </Typography>
                    </>
                  )}
                </Button>
              );
            })}
        </List>
      </Collapse>
    </>
  );
};
